<ng-container *ngIf="isSMSCounter">
  {{ counter.contentLength }}/{{ counter.maxLength }}
  ({{ counter.smsLength }} {{ 'messages.max' | translate:{ max: '10' } }})
</ng-container>
<ng-container *ngIf="!isSMSCounter && messageLength <= maxLength">
  {{ messageLength }}/{{ maxLength }}
</ng-container>
